import clsx from 'clsx';

interface Props {
  title: string;
  marginTop?: string;
  marginBottom?: string;
}

export default function AuthHeader({ title, marginBottom = 'mb-[40px]' }: Props) {
  return (
    <>
      <div className="flex items-center justify-center ">
        <img src="/PHMG-logo.svg" alt="PHMG Logo" className={'w-[40px] max-sm:w-[32px]'} />
      </div>
      <div className={clsx('text-[35px] max-sm:text-[24px] w-full text-center', marginBottom)}>{title}</div>
    </>
  );
}
